import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ListIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '70%' : '100%'}
      height={circled ? '70%' : '100%'}
      viewBox="0 0 11.723 13.457"
    >
      <defs>
        <clipPath>
          <rect width="11.723" height="13.457" transform="translate(0 0)" fill="none" stroke={color} strokeWidth="1" />
        </clipPath>
      </defs>
      <g transform="translate(0 0)">
        <line
          x1="5.313"
          transform="translate(3.205 6.192)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line
          x1="5.313"
          transform="translate(3.205 3.649)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <line
          x1="5.313"
          transform="translate(3.205 8.735)"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <g>
          <g clipPath="url(#clipPath)">
            <rect
              width="10.723"
              height="12.457"
              rx="0.52"
              transform="translate(0.5 0.5)"
              fill="none"
              stroke={color}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
        </g>
      </g>
    </svg>
  </CircledIcon>
);
